var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { attrs: { "no-gutters": "" } },
    [
      _c(
        "b-col",
        { staticClass: "text-center mb-1", attrs: { cols: "12" } },
        [
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.left.hover",
                  value: "Zoom In",
                  expression: "'Zoom In'",
                  modifiers: { left: true, hover: true },
                },
              ],
              staticClass: "btn-sm mr-1",
              attrs: { variant: "white" },
              on: {
                click: function ($event) {
                  return _vm.handleActionClick("zoom-in")
                },
              },
            },
            [_c("icon", { attrs: { name: "plus" } })],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "text-center mb-1", attrs: { cols: "12" } },
        [
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.left.hover",
                  value: "Zoom Out",
                  expression: "'Zoom Out'",
                  modifiers: { left: true, hover: true },
                },
              ],
              staticClass: "btn-sm mr-1",
              attrs: { variant: "white" },
              on: {
                click: function ($event) {
                  return _vm.handleActionClick("zoom-out")
                },
              },
            },
            [_c("icon", { attrs: { name: "minus" } })],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "text-center mb-1", attrs: { cols: "12" } },
        [
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.left.hover",
                  value: "Rotate Left",
                  expression: "'Rotate Left'",
                  modifiers: { left: true, hover: true },
                },
              ],
              staticClass: "btn-sm mr-1",
              attrs: { variant: "white" },
              on: {
                click: function ($event) {
                  return _vm.handleActionClick("rotate-left")
                },
              },
            },
            [_c("icon", { attrs: { name: "undo" } })],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "text-center mb-1", attrs: { cols: "12" } },
        [
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.left.hover",
                  value: "Rotate Right",
                  expression: "'Rotate Right'",
                  modifiers: { left: true, hover: true },
                },
              ],
              staticClass: "btn-sm mr-1",
              attrs: { variant: "white" },
              on: {
                click: function ($event) {
                  return _vm.handleActionClick("rotate-right")
                },
              },
            },
            [_c("icon", { attrs: { name: "repeat" } })],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "text-center mb-1", attrs: { cols: "12" } },
        [
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.left.hover",
                  value: "Reset",
                  expression: "'Reset'",
                  modifiers: { left: true, hover: true },
                },
              ],
              staticClass: "btn-sm mr-1",
              attrs: { variant: "white" },
              on: {
                click: function ($event) {
                  return _vm.handleActionClick("reset")
                },
              },
            },
            [_c("icon", { attrs: { name: "times" } })],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }